import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import custom_store from 'devextreme/data/custom_store';
import { Subscription } from 'rxjs';
import { ConstantsService } from 'src/app/services/constants.service';
import { enumProductClass } from '../../model/SaleItem';

export class SalesTransaction {
  Id: number;
  TransactionDateTime: string;
  BranchName: string;
  Client: string;
  ProductClass: number;
  ProductDetail: string;
  ProductPrice: number;
  ProductQuantity: number;
  ProductTotal: number;
  PaymentMethod: string;
  TransactionType: string;
  TransactionHeader: number;
  TransactionTotal: number;
  TransactionTotalCash: number;
  TransactionTotalCard: number;
}

@Component({
  selector: 'app-sales-transaction-list',
  templateUrl: './sales-transaction-list.component.html',
  styleUrls: ['./sales-transaction-list.component.css'],
})
export class SalesTransactionListComponent implements OnChanges {
  @Input() popupVisible: boolean = false;
  @Input() cashUpDialogVisible: boolean = false;
  @Output() closeDlg: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataSource: custom_store<any, any>;
  closeBtnOptions: any;
  summaryTotals: any;
  onBranchChanged$: Subscription;

  constructor() {
    this.closeBtnOptions = {
      text: 'Close',
      onClick: this.btnClose.bind(this),
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.popupVisible.currentValue === true) {
      this.dataSource = AspNetData.createStore({
        key: 'Id',
        loadUrl: '/api/Transactions/SalesTransactionList',
        onBeforeSend: (e, ajax) => {
          ajax = ConstantsService.AddDefaultHeaders(e, ajax);
        },
        onLoaded: (salesTransactionArr: SalesTransaction[]): void => {
          let totalCard: number = 0;
          let totalCash: number = 0;
          let totalCourse: number = 0;
          let totalProduct: number = 0;
          let totalSession: number = 0;

          const processedTransactionHeaders: number[] = [];
          const length = salesTransactionArr.length;

          for (let i = 0; i < length; i++) {
            const salesTransaction: SalesTransaction = salesTransactionArr[i];

            if (processedTransactionHeaders.lastIndexOf(salesTransaction.TransactionHeader) === -1) {
              processedTransactionHeaders.push(salesTransaction.TransactionHeader);
              totalCard += salesTransaction.TransactionTotalCard;
              totalCash += salesTransaction.TransactionTotalCash;
            }

            if (salesTransaction?.ProductClass === enumProductClass.Course) {
              totalCourse += salesTransaction.ProductTotal;
            } else if (salesTransaction?.ProductClass === enumProductClass.Product) {
              totalProduct += salesTransaction.ProductTotal;
            } else if (salesTransaction?.ProductClass === enumProductClass.Session) {
              totalSession += salesTransaction.ProductTotal;
            }
          }

          this.summaryTotals = [
            {
              TotalCard: '£' + totalCard.toFixed(2),
              TotalCash: '£' + totalCash.toFixed(2),
              TotalProduct: '£' + totalProduct.toFixed(2),
              TotalSession: '£' + totalSession.toFixed(2),
              TotalCourse: '£' + totalCourse.toFixed(2),
            },
          ];
        },
      });
    }
  }

  btnClose(): void {
    this.closeDlg.emit();
  }

  onShown(_e: any): void {
    this.dataGrid.instance.refresh();
  }

  onHidden(_e: any): void {
    this.closeDlg.emit();
  }
}
